import React from 'react'
import classnames from 'classnames'
import { DeleteIcon, CloseIcon } from '@myxplor/icons'
import { FormButton, FormSelect, FormDisplayErrors } from '@myxplor/forms'
import { Pill } from '@myxplor/ui'
import Grid from '../../../../../ui/grid'
import './session.css'

export const name = ({ first_name, last_name }) => [first_name, last_name].join(' ')

export const educatorFromID = (educators = [], { personnel_id }) =>
  educators.filter(({ id }) => String(id) === String(personnel_id))[0]

const educatorsOptions = educators =>
  educators.map(educator => ({
    label: name(educator),
    value: educator.id,
  }))

const formatTime = ({ hours, minutes }) => hours + ':' + minutes

const hoursOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(h => ({value: h}))

const minutesOptions = ['00', '15', '30', '45'].map(h => ({
  value: h,
}))

const Session = ({
  educators,
  isEditing,
  changeEditingSession,
  resetEditingSession,
  onChange,
  values,
  nameBase,
  removeKey,
  isOverTime,
}) => {
  if (!isEditing) {
    return (
      <li className="weekDay--session weekDay--session__clickable" onClick={changeEditingSession}>
        <Pill noUpperCase warning={isOverTime}>
          {name(educatorFromID(educators, values))} for {formatTime(values)}hrs
        </Pill>
      </li>
    )
  }

  return (
    <li>
      <fieldset
        className={classnames({
          'weekDay--sessionFields': true,
          'weekDay--sessionFields__overTime': isOverTime,
        })}>
        <FormButton right onClick={resetEditingSession}>
          <CloseIcon />
        </FormButton>

        <Grid small>
          <FormSelect
            name={nameBase + '.personnel_id'}
            label="Person"
            options={educatorsOptions(educators)}
            value={values.personnel_id}
            onChange={onChange}
            compact
          />

          <div className="inputWrapper issCaseClaim--educatorTimeFrame">
            <FormSelect
              name={nameBase + '.hours'}
              label="Hours"
              options={hoursOptions}
              value={values.hours}
              onChange={onChange}
              compact
            />

            <FormSelect
              name={nameBase + '.minutes'}
              label="Minutes"
              options={minutesOptions}
              value={values.minutes}
              onChange={onChange}
              compact
            />
          </div>

          {isOverTime && (
            <FormDisplayErrors errors="You are claiming more hours than what is permitted for this ISS Case" />
          )}

          <FormButton
            className="weekDay--removeSession"
            left
            onClick={() => {
              resetEditingSession()
              removeKey(nameBase)
            }}>
            <DeleteIcon left /> Remove session
          </FormButton>
        </Grid>
      </fieldset>
    </li>
  )
}

export default Session



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/select-session/session.jsx